import AppHeader from '../AppHeader'
import { send } from 'q';
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js'

let utils = require('../../utils')

export default {
  name: 'introduction',
  created () {
    this.getDate()
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      introduction: "",
      step: 1,
      friendFirstName: "",
      friendLastName: "",
      friendFirstNameKana: "",
      friendLastNameKana: "",
      friendNowJob: "",
      friendNowJobOther: "",
      friendEmail: "",
      friendPhoneNumber: "",
      requestShopId: "",
      friendRequest: "",
      currentYear: "",
      desiredYear: "",
      desiredMonth: "",
      desiredDay: "",
      dayCount: "",
      canChoiceYears: [],
      referrals: [],
      shopName: "",
      swiperOption: {
        speed: 500,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    checkName () {
      return !this.friendFirstName || !this.friendLastName
    },
    checkNameKana () {
      return !this.friendFirstNameKana || !this.friendLastNameKana
    },
    checkBirthday () {
      return !this.desiredYear || !this.desiredMonth || !this.desiredDay
    },
    checkNowJob () {
      if (this.friendNowJob === this.$t('friend_now_job.other')) {
        return !this.friendNowJobOther
      } else {
        return !this.friendNowJob
      }
    },
    checkNowJobOther () {
      return this.friendNowJob === this.$t('friend_now_job.other')
    },
    checkPhoneNumber: function () {
      // 電話番号の正当性チェック関数
      // +81は日本の電話番号を示す
      let validateTelNeo = function (value) {
        const phoneNumber = parsePhoneNumberFromString('+81' + value, 'JA')
        if (phoneNumber) {
          return phoneNumber.isValid()
        } else {
          return false
        }
      }

      // 整形関数
      let formatTel = function (value) {
        return new AsYouType('JP').input(value)
      }

      // ハイフン有無確認関数
      let haihun = RegExp('-')

      if (!validateTelNeo(this.friendPhoneNumber)) {
        return true
      } else {
        // 整形
        let tempNumber = formatTel(this.friendPhoneNumber)
        // ハイフン有無確認
        if (haihun.test(tempNumber)) {
          this.friendPhoneNumber = tempNumber
        } else {
          return true
        }
      }
    },
    checkEmail () {
      let checkEmail = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/)
      return !this.friendEmail || !checkEmail.test(this.friendEmail)
    },
    checkAll: function() {
      return !(!this.checkName && !this.checkNameKana && !this.checkBirthday && !this.checkNowJob && !this.checkPhoneNumber && !this.checkEmail)
    },
    googleMapAddress: function() {
      return `https://maps.google.co.jp/maps?q=${this.introduction['shop-address']}&output=embed&t=m&z=15&hl=ja`
    }
  },
  components: {
    AppHeader
  },
  methods: {
    getDate: function () {
      let today = new Date()
      this.currentYear = today.getFullYear()
      for (let i = 18; i < 100; i++) {
        this.canChoiceYears.push(this.currentYear - i)
      }
      let calcMonth = today.getMonth() + 1
      let calcDay = today.getDate()
      this.dayCount = new Date(
        calcMonth,
        calcDay,
        0
      ).getDate()
    },
    search: function () {
      let data = {
        send_token: this.$route.params.send_token
      }
      this.$store.dispatch('GET_INTRODUCTION', data)
      .then(res => {
        this.introduction = res.data.introduction.data.attributes
        this.referrals = res.data.referrals.data
        if (this.introduction['is-sent'] === 1) {
          this.step = 3
        }
        this.friendFirstName = this.introduction['friend-first-name']
        this.friendLastName = this.introduction['friend-last-name']
        this.friendFirstNameKana = this.introduction['friend-first-name-kana']
        this.friendLastNameKana = this.introduction['friend-last-name-kana']
        this.desiredYear = this.introduction['friend-birthday-year']
        this.desiredMonth = this.introduction['friend-birthday-month']
        this.desiredDay = this.introduction['friend-birthday-day']
        this.friendNowJob = this.introduction['friend-now-job']
        this.friendNowJobOther = this.introduction['friend-now-job-other']
        this.friendPhoneNumber = this.introduction['friend-phone-number']
        this.friendEmail = this.introduction['friend-email']
        this.requestShopId = this.introduction['request-shop-id']
        this.friendRequest = this.introduction['friend-request']
        this.shopName = this.introduction['shop-name']
        this.searchCallbackFlag = true
      })
      .catch(err => console.log(err));
    },
    content: function (word) {
      word = word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      var re_url = /((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?)/gi;
      word = word.replace(re_url, '<a href="$1" target="_blank" style="color: #337ab7">$1</a>').replace(/\r?\n/g, '<br>')
      return word
    },
    goStep: function() {
      this.step += 1
      if (this.step === 2) {
        window.scroll(0,0)
      }
      if (this.step === 3) {
        this.send()
      }
    },
    backStep: function() {
      this.step -= 1
      window.scroll(0,0)
    },
    goRecruit: function() {
      document.getElementById('startRecruitContents').scrollIntoView()
    },
    goAccess: function() {
      document.getElementById('access').scrollIntoView()
    },
    goEntry: function() {
      document.getElementById('entry').scrollIntoView()
    },
    send: function() {

      let data = {
        send_token: this.$route.params.send_token,
        referral_id: this.introduction['referral-id'],
        friend_first_name: this.friendFirstName,
        friend_last_name: this.friendLastName,
        friend_first_name_kana: this.friendFirstNameKana,
        friend_last_name_kana: this.friendLastNameKana,
        friend_birthday_year: this.desiredYear,
        friend_birthday_month: this.desiredMonth,
        friend_birthday_day: this.desiredDay,
        friend_now_job: this.friendNowJob,
        friend_now_job_other: this.friendNowJobOther,
        friend_phone_number: this.friendPhoneNumber,
        friend_email: this.friendEmail,
        request_shop_id: this.requestShopId,
        friend_request: this.friendRequest
      }
      this.$store.dispatch('PATCH_INTRODUCTION', data)
      .then(res => {
        console.log(res)
      })
      .catch(err => console.log(err));
    },
    kanaSupport: function (target) {
      let data = {}
      if (target === 'lastname') {
        data = {
          'user_name': this.friendLastName
        }
      } else {
        data = {
          'user_name': this.friendFirstName
        }
      }
      this.$store.dispatch('KANA_GET', {data: data})
        .then(res => {
          if (target === 'lastname') {
            this.friendLastNameKana = res
          } else {
            this.friendFirstNameKana = res
          }
        })
        .catch(err => console.log(err))
    },
    getDayCount: function () {
      this.dayCount = new Date(
        this.desiredYear,
        this.desiredMonth,
        0
      ).getDate()
    },
    changeReferral: function () {
      for (let i = 0; i < this.referrals.length; i++) {
        if (this.referrals[i].attributes['shop-id'] === this.requestShopId) {
          this.introduction['job-category'] = this.referrals[i].attributes['job-category']
          this.introduction['work-style-i18n'] = this.referrals[i].attributes['work-style']
          this.introduction['referral-id'] = this.referrals[i].id
          this.introduction['salary'] = this.referrals[i].attributes['salary']
          this.introduction['work-hours'] = this.referrals[i].attributes['work-hours']
          this.introduction['work-detail'] = this.referrals[i].attributes['work-detail']
          this.introduction['welfare'] = this.referrals[i].attributes['welfare']
          this.introduction['shop-address'] = this.referrals[i].attributes['shop-address']
          this.shopName = this.referrals[i].attributes['shop-name']
        }
      }
      document.getElementById('startRecruitContents').scrollIntoView()
    },
    wordReplace: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/introduction.js